import { render, staticRenderFns } from "./BrandNameCombobox.vue?vue&type=template&id=a3be296e&"
import script from "./BrandNameCombobox.vue?vue&type=script&lang=ts&"
export * from "./BrandNameCombobox.vue?vue&type=script&lang=ts&"
import style0 from "./BrandNameCombobox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports